export const excerciseIconMap = type => ({
  bicycle: 'directions_bike',
  default: 'bar_chart',
  hike: 'landscape',
  rowing: 'rowing',
  run: 'directions_run',
  swim: 'pool',
  walk: 'directions_walk',
}[type ? type.toLowerCase() : 'default']) || 'bar_chart';